import MakeTag from "../makeTag/MakeTag";
export default function PythonTag() {
  return (<>
    <MakeTag tagText="Arduino" color="#009297" />
    <MakeTag tagText="C++" color="#6092c7" />

  </>);
}